import { Box, Grid, Typography } from "@mui/material"
import KeyIcon from '@mui/icons-material/Key';

import { DlspTable } from "./DlspTable"
import { safeFormatDate } from "../../../utils/utilityFunctions"


export function DesktopQADetails({desktopQABy, desktopQAOwner, desktopQADate, desktopQA}) {

    const leftTableRows = []
    leftTableRows.push({label: 'Desktop QA Complete', text: desktopQA?.desktopQAComplete})
    leftTableRows.push({label: 'Desktop QA Comments', text: desktopQA?.desktopQAComments})
    if (desktopQA?.nextStatus === 'Field') {
        const landOwnerLabel = <><KeyIcon /><br /><span>Land Owner Permission Required</span></>
        leftTableRows.push({label: 'Field Inspection Photos Required', text: desktopQA?.fieldPhotosRequired})
        leftTableRows.push({label: landOwnerLabel,   text: desktopQA?.landOwnerPermissionRequired})
    }
    if (desktopQA?.nextStatus === 'Remedial') {
        leftTableRows.push({label: "Remedial Work Priority",   text: desktopQA?.remedialPriority})
    }


    const rightTableRows = []
    rightTableRows.push({label: 'Next Status', text: desktopQA?.nextStatus})

    return (
        <Box sx={{my: 2}}>
            {/* <Box>
                <Typography variant="body2">Owner: {desktopQAOwner}</Typography>
            </Box> */}
            {
            (desktopQABy && desktopQADate && desktopQA)
            &&
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="body2"><strong>{desktopQABy}</strong></Typography>
                    <Typography variant="body2"><strong>{safeFormatDate(desktopQADate, 'd MMMM yyyy HH:mm a')}</strong></Typography>

                </Grid>
                <Grid item md={6}>
                    <DlspTable rows={leftTableRows} skipHeader={true} />
                </Grid>
                <Grid item md={6}>
                    <DlspTable rows={rightTableRows} skipHeader={true} />
                </Grid>
            </Grid>
            }
        </Box>
    )
}